import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { IRBHistory } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetRBDataHistories = (
  locationCode: string,
  date: string,
  enabled = true,
) => {
  const filters = [`location_code=${locationCode}`, `date=${date}`];

  return useQuery({
    queryKey: queryKeys.rbDataHistory.all(filters),
    queryFn: () => fetchRBDataHistories(filters),
    enabled: enabled && !isEmpty(filters),
    staleTime: Infinity,
  });
};

const fetchRBDataHistories = async (filters: string[] = []) => {
  const query = generateQuery([], filters);

  const url = `/rbDataHistory${query}`;

  const response = await requestCCApi({ url });

  return (response as IRBHistory).versions;
};
